export default __webpack_public_path__ + "static/media/design-0.f3915851.svg";